import {
  MockMap,
} from '@ama-sdk/core';
import {
  combineTravelers,
  TravelerRepository,
} from '@dapi/sdk/spec';
import {
  contactEmail,
  contactPhone,
} from 'src/mock/dictionaries';
import {
  acknowledgeSuccess,
  getAlternativeOfferConfirmationJobCompleted,
} from '../../../../src/mock/data/index';
import {
  createAsynchronousJobForAlternativeOfferConfirmationSuccess,
  flightOutBoundInt,
  getAlternativeOffersDisruptedOneWay,
  order,
  outBoundInt,
} from '../data/index';
import {
  getOrderEligibilitiesMock,
  orderEligibilities,
  orderEligibilitiesAcknwoledged,
} from '../data/order-eligibilities';
import {
  vipOrderServiceItemADT,
  vipTransOrderServiceItemADT
} from '../data/order-services';
import {
  paymentRecord1Adt1InfService1
} from '../data/payment';

const TRAVELERS = combineTravelers([TravelerRepository.MAN,TravelerRepository.INF]).items;
const CONTACTS = [contactPhone, contactEmail];
const ORDER = {
  ...order,
  air: {prices: {...order.air.prices},
    bounds: [
      outBoundInt
    ]},
  services: [vipOrderServiceItemADT,vipTransOrderServiceItemADT],
  travelers: TRAVELERS,
  contacts: CONTACTS,
  paymentRecords: [paymentRecord1Adt1InfService1],
  orderEligibilities: orderEligibilities
};

const retrieveDisruptedOrder = {
  warnings: [
    {
      code: '65227',
      title: 'FLIGHT DISRUPTION HAS OCCURRED: CHECK THE ORDER CONTENT'
    }
  ],
  data: ORDER,
  dictionaries: {
    flight: {
      ST2: flightOutBoundInt,
      ST1: {
        ...flightOutBoundInt,
        flightStatus: 'cancelled',
        aircraftConfigurationVersion: '350'
      }
    }
  }
};

const retrieveConfirmedOrder = {
  data: {...ORDER,
    orderEligibilities: orderEligibilitiesAcknwoledged,
    services: [vipTransOrderServiceItemADT],
    air: {prices: {...order.air.prices},
      bounds: [{...outBoundInt,
        flights: [
          {
            id: 'ST2',
            bookingClass: 'E',
            statusCode: 'HK'
          }
        ],
        disruptionStatus: {
          ...outBoundInt.disruptionStatus,
          originalFlights: [
            {
              id: 'ST1'
            }
          ]
        }}]}},
  dictionaries: {
    ...retrieveDisruptedOrder.dictionaries
  }
};

export const disruptedOneway1Adt1infVipEcoMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveDisruptedOrder
    },
    {
      mockData: retrieveConfirmedOrder
    }
  ],
  getOrderEligibilities: [
    {
      mockData: getOrderEligibilitiesMock
    }],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersDisruptedOneWay
    }
  ],
  createAsynchronousJobForAlternativeOfferConfirmation: [
    {
      mockData: createAsynchronousJobForAlternativeOfferConfirmationSuccess
    }
  ],
  getAlternativeOfferConfirmationJob: [
    {
      mockData: getAlternativeOfferConfirmationJobCompleted
    }
  ],
  acknowledge: [
    {
      mockData: acknowledgeSuccess
    }
  ],
  sendNotifications: [{
    mockData: {}
  }]
};
